import { Country } from '@/helpers/conf';

export const ANJOUAN_COUNTRIES = [
  Country.India,
  Country.Zimbabwe,
  Country.Canada,
];
